import { getDeviceViewLabel, isDownwardCameraPosition } from '../episodeMetadata';

interface EpisodeMetadataBadgesProps {
  cameraPosition: string | null;
  deviceTypeEnum: number | null;
}

export function EpisodeMetadataBadges({
  cameraPosition,
  deviceTypeEnum,
}: EpisodeMetadataBadgesProps) {
  const deviceLabel = getDeviceViewLabel(deviceTypeEnum);
  const cameraFacingDown = isDownwardCameraPosition(cameraPosition);
  if (!deviceLabel && !cameraFacingDown) return null;

  return (
    <div className="mt-1 flex flex-wrap items-center gap-1.5" data-testid="episode-metadata-badges">
      {cameraFacingDown && (
        <span
          className="rounded border border-red-500/50 bg-red-500/10 px-2 py-0.5 text-xs font-semibold text-red-300"
          title={`cameraPosition: ${cameraPosition}`}
          data-testid="camera-position-down-badge"
        >
          手部镜头朝下
        </span>
      )}
      {deviceLabel && (
        <span
          className="rounded border border-brand-border bg-brand-surface px-2 py-0.5 text-xs font-medium text-brand-text-secondary"
          title={`deviceTypeEnum: ${deviceTypeEnum}`}
          data-testid="device-view-badge"
        >
          {deviceLabel}
        </span>
      )}
    </div>
  );
}
